import { styled } from '@mui/material/styles';
import { Box, Theme } from '@mui/material';

interface DrawerHeaderStyledProps {
  theme: Theme;
  open: boolean;
}

const DrawerHeaderStyled = styled(Box, {
  shouldForwardProp: (prop: string) => prop !== 'open',
})<DrawerHeaderStyledProps>(({ open }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: open ? 'flex-start' : 'center',
  minHeight: 78,
  borderBottom: '1px solid rgba(255, 255, 255, 0.06)',
  marginBottom: 4,
  padding: open ? '8px 10px' : '8px 0',
}));

export default DrawerHeaderStyled;
